import { Button, Col, Form, Input, Row, Space, theme, Table, Select, Tooltip, message, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { FORMAT_DATE, HeaderTableCus, TYPE_METHOD_SUPPORT, TYPE_RESULT_SUPPORT } from '../../constants/constants';
import { SearchOutlined } from '@ant-design/icons';
import { filterOption, getSelectedBranch } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import { customer_services_detail, customer_services_update_status, getListAccount, getListBranches, list_customer_care_logs } from '../../services/apis';
import ServiceDetailModal from './modal/ServiceDetailModal';


const ListLogsSupportPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        date: [dayjs().startOf('day'), dayjs().endOf('day')],
        branch_id: getSelectedBranch()?.id ?? null,
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [employees, setEmployees] = useState([]);
    const [isShowModalDetailService, setIsShowModalDetailService] = useState(false);
    const [dataPositions, setDataPositions] = useState([]);
    const [dataBranches, setDataBranches] = useState([]);
    const { RangePicker } = DatePicker;
    const columns = [
        {
            title: 'STT',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div>{(currentPage - 1) * currentPageSize + index + 1}</div>,
        },
        {
            title: 'Nhân viên chăm sóc',
            dataIndex: 'employee_name',
            key: 'employee_name',
            width: 200,
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 0, paddingRight: 8 }}>{text}</a>
            </div>,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 0, paddingRight: 12
                }}>
                {text}
            </div>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customer_phone',
            key: 'customer_phone',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Phương thức CSKH',
            dataIndex: 'care_method',
            key: 'care_method',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{TYPE_METHOD_SUPPORT.find(item => item.value === text)?.label}</div>,
        },
        {
            title: 'Kết quả CSKH',
            dataIndex: 'care_result',
            key: 'care_result',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{TYPE_RESULT_SUPPORT.find(item => item.value === text)?.label}</div>,
        },
        {
            title: 'Ghi chú',
            dataIndex: 'notes',
            key: 'notes',
            width: 120,
            render: (text, record, index) => <div>{text?.length > 50 ?
                <Tooltip
                    placement="topLeft"
                    title={text}
                >
                    <span>{text?.substring(0, 50)}...</span>
                </Tooltip> : `${text}`
            }</div>,
        },
        {
            title: 'Thời gian',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 90,
            align: 'center',
        },
    ];
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataServiceDetail = async (service_id) => {

        try {
            const params = {
                id: service_id,
            }
            setLoading(true);
            const res = await customer_services_detail(params);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModalDetailService(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }

    }


    const getDataLogsSupport = async (page, showLoading, pageSize) => {
        try {
            const params = {
                employee_id: form.getFieldValue('employee_id') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                page: page ?? currentPage,
                limit: pageSize ?? currentPageSize,
                date_from: form.getFieldValue('date') ? dayjs(form.getFieldValue('date')[0]).startOf('day').format(FORMAT_DATE.YYYYMMDDHHMMSS) : null,
                date_to: form.getFieldValue('date') ? dayjs(form.getFieldValue('date')[1]).endOf('day').format(FORMAT_DATE.YYYYMMDDHHMMSS) : null,
            }
            if (showLoading) setLoading(true);
            const res = await list_customer_care_logs(params);
            if (showLoading) setLoading(false);
            consoleLogUtil("res list_customer_care_logs", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {

        }

    }

    const getDataUsers = async () => {
        try {
            const params = {
                keyword: '',
                branch_id: getSelectedBranch()?.id ?? null,
                limit: 100,
                currentPage: 1,
            }

            const res = await getListAccount(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.fullname }))]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const onFinish = async (dataForm) => {
        setCurrentPage(1);
        getDataLogsSupport(1, true);
    };

    const handleSaveServiceDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                status: data?.status,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await customer_services_update_status(params);
            if (res && res.status === 1) {
                message.success('Cập nhật dịch vụ thành công');
                getDataLogsSupport(1, true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setDataBranches([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setDataBranches([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataUsers(), getDataBranches()]).finally(() => setLoading(false));
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataLogsSupport(1, true)
        }
    }, [form])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={5}>
                        <Form.Item
                            name={'employee_id'}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn nhân viên'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={employees}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataBranches}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                format={FORMAT_DATE.DDMMYYYY}
                                allowClear={false}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='custom-input-antd'
                                >
                                    <SearchOutlined /> Lọc dữ liệu
                                </Button>
                            </Tooltip>

                        </Space>
                    </Col>
                </Row>
            </Form>

            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                bordered
                rowKey={(record) => record?.customer_service_id}
                scroll={{ x: 'max-content' }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            getDataServiceDetail(record?.customer_service_id);
                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataLogsSupport(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} lần hỗ trợ`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataLogsSupport(1, true, size);
                    }
                }}
            />

            <ServiceDetailModal
                visible={isShowModalDetailService}
                onClose={() => setIsShowModalDetailService(false)}
                data={itemSelected}
                employees={employees}
                positions={dataPositions}
                onSave={handleSaveServiceDetail}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListLogsSupportPage);